import { Injectable, Injector } from '@angular/core';
import { EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { AbstractRepositoryV2 } from 'src/app/modules/core/service/v2/abstractRepositoryV2';
import { ProviderServiceOptionModel } from '../../../api/entity/providerServiceOption.model';

@Injectable({
    providedIn: 'root'
})
export class ProviderServiceOptionRepository extends AbstractRepositoryV2<ProviderServiceOptionModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('ProviderServiceOption', serviceElementsFactory, injector);
    }
}

